export enum SamlErrorType {
    AccessDenied = 'access_denied',
    FlowError = 'flow_error',
    UnknownBsn = 'unknown_bsn',
}
